import { createAction, props } from '@ngrx/store';
import { IElement } from '@studio/domain/creativeset/element';
import { IVersionProperty } from '@studio/domain/creativeset/version';
import { IBfFeed } from '@studio/domain/feed';

export const loadTranslationPage = createAction('[TranslationPage] Load TranslationPage');

export const loadTranslationPageSuccess = createAction(
    '[TranslationPage] Load TranslationPage Success',
    props<{
        elements: IElement[];
    }>()
);

export const loadTranslationPageFailure = createAction(
    '[TranslationPage] Load TranslationPage Failure',
    props<{ error: unknown }>()
);

export const initializeFeedStoreSingleton = createAction(
    '[TranslationPage] Initialize FeedStoreSingleton'
);

export const updateElementsOnSizeChange = createAction(
    '[TranslationPage] Update Elements On Size Change'
);

export const updateElementsOnSizeChangeSuccess = createAction(
    '[TranslationPage] Update Elements On Size Change Success',
    props<{
        elements: IElement[];
    }>()
);

export const selectElement = createAction(
    '[TranslationPage] Select element',
    props<{ elementId: string }>()
);

export const selectNextElement = createAction('[TranslationPage] Select Next Element');

export const selectPreviousElement = createAction('[TranslationPage] Select Previous Element');

export const upsertDirtyVersionProperty = createAction(
    '[TranslationPage] Upsert Dirty Version Property',
    props<{
        versionId: string;
        versionProperty: IVersionProperty;
    }>()
);

export const removeDirtyVersionProperty = createAction(
    '[TranslationPage] Remove Dirty Version Property',
    props<{
        versionId: string;
        versionPropertyId: string;
    }>()
);

export const cancelTranslations = createAction('[TranslationPage] Cancel Translations');

export const saveDirtyVersions = createAction('[TranslationPage] Save Dirty Versions');

export const saveDirtyVersionsSuccess = createAction('[TranslationPage] Save Dirty Versions Success');

export const saveDirtyVersionsFailure = createAction(
    '[TranslationPage] Save Dirty Versions Failure',
    props<{ error: unknown }>()
);

export const showAllElements = createAction('[TranslationPage] Show All Elements');

export const hideAllElements = createAction('[TranslationPage] Hide All Elements');

export const initBfFeeds = createAction(
    '[TranslationPageI] Initialize Bf Feeds',
    props<{ feeds: IBfFeed[] }>()
);
